var shuffleSeed = require("shuffle-seed");

function map(value, in_min, in_max, out_min, out_max, clamp = true) {
  let val =
    ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
  if (clamp) {
    return this.clamp(val, 0, 1);
  }
  return val;
}

function clamp(input, min, max) {
  return input < min ? min : input > max ? max : input;
}

const removeElement = (array, itemId) => {
  const newArr = array.filter((el) => el.dbid !== itemId)
  return newArr

};

const shuffleArray = (array) => {
  return shuffleSeed.shuffle(array, Date.now());
};

const roundTo = (num, decimals = 2) => {
  return parseFloat(num.toFixed(decimals))
}


const TIME_DIVISIONS = [
  { amount: 60, name: "seconds" },
  { amount: 60, name: "minutes" },
  { amount: 24, name: "hours" },
  { amount: 7, name: "days" },
  { amount: 4.34524, name: "weeks" },
  { amount: 12, name: "months" },
  { amount: Number.POSITIVE_INFINITY, name: "years" },
]

const formatTimeAgo = (date,lang) => {
  let duration = (date - new Date()) / 1000

  for (let i = 0; i < TIME_DIVISIONS.length; i++) {
    const division = TIME_DIVISIONS[i]
    if (Math.abs(duration) < division.amount) {
      return  new Intl.RelativeTimeFormat(lang, {
        numeric: "auto",
      }).format(Math.round(duration), division.name)
    }
    duration /= division.amount
  }
}

export { map, clamp, removeElement, shuffleArray, roundTo, formatTimeAgo};